import { render } from "./MessagesPage.vue?vue&type=template&id=abc13cf2&scoped=true"
import script from "./MessagesPage.vue?vue&type=script&lang=js"
export * from "./MessagesPage.vue?vue&type=script&lang=js"

import "./MessagesPage.vue?vue&type=style&index=0&id=abc13cf2&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc13cf2"]])

export default __exports__